import { NormalizedPublicListing } from 'types/listingV3';
import type { PublicListingV3 } from 'types/listingV3';

const normalizeListingV3 = (
  listing: PublicListingV3,
): NormalizedPublicListing => {
  return {
    bookingAvailabilityMode: listing.bookingAvailabilityMode,
    brandId: listing.brandId,
    categoryId: listing.category?.id ?? undefined,
    categoryName: listing.category?.name ?? undefined,
    dates: listing.eventDates,
    experienceId: listing.experienceId,
    hidePrice: listing.hidePrice,
    hostedBy: listing.hostedBy,
    id: listing.id,
    isExclusive: listing.isExclusive,
    kind: listing.kind,
    maxParticipants: listing.maxParticipants,
    medias: listing.medias,
    pointsEligible: listing.pointsEligible,
    productLine: listing.productLine,
    promotedListing: listing.promotedListing,
    rating: listing.rating,
    resourceGroupCollectionId: listing.resourceGroupCollectionId,
    resourceGroups: listing.resourceGroups,
    advertisedPrice: listing.advertisedPrice,
    slug: listing.slug,
    startingPrice: listing.startingPrice,
    summary: listing.summary,
    title: listing.title,
    vibes: listing.vibes,
  };
};

export default normalizeListingV3;
